import axios from 'axios'
import { toast } from 'react-toastify'

const Axios = axios.create({
    baseURL: import.meta.env.VITE_BACKEND_URL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
})

Axios.interceptors.request.use(
    (config) => {
        
        const token = window.localStorage.getItem('_token')
        if (token) {
            config.headers['Authorization'] = 'token ' + token
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

Axios.interceptors.response.use(
    (response) => {
        
        if (response.status !== 200 && response.data?.success) {
            if(!["Data Validated successfully"].includes(response.data.message)){
                toast.success(response.data.message)
            }
        } else {
            toast.success(response.status.message)
        }
        return response
    },
    (error) => {
        console.log("error?.response L ", error)
        if (error?.response && error?.response?.status === 401) {
            toast.error('Session expired or unauthorized, redirecting to login...')
            window.localStorage.removeItem('_token')
            window.location.href = '/login'
        }else if (error?.response && error?.response?.status === 500) {
            if(error?.response?.data?.status_code == 422){
                toast.error(error?.response?.data?.data?.errors)
            }
        }else if (error?.response && error?.response?.status === 422) {
            toast.error(error?.response?.data?.data?.errors)
        }else if (error?.response?.data?.message) {
            toast.error(error?.response?.data?.message.replace("frappe.exceptions.", "").replace("ValidationError:", ""))
        } else if (error?.response?.data?.exception) {
            toast.error(error?.response?.data?.exception.replace("frappe.exceptions.", "").replace("ValidationError:", ""))
        } else if (error?.message) {
            toast.error(error?.message)
        }

        return Promise.reject(error)
    }
)

export default Axios
